var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"area"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"text-center"},[_vm._v("Non è possibile accedere alla pagina")])]),_c('div',{staticClass:"card-body"},[_c('p',[_vm._v(" Verifica che il link sia corretto e che tu sia in possesso dei permessi per accedere alla risorsa richiesta. ")])])])])
}]

export { render, staticRenderFns }